import React, { useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import PageLoader from '../components/PageLoader';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import VerificationRoutes from './VerificationRoutes';
// import CommonRoutes from './CommonRoutes';
import { AvailabilityResetTime } from '../common/Config';
import DashBoardLayout from './DashboardLayout';
import CheckoutController from '../controllers/CheckoutController';
import HomeController from '../controllers/HomeController';
import AttractionDetailController from "../controllers/AttractionDetailController";
import LocationDetailController from "../controllers/LocationDetailController";
import ProductFilterController from "../controllers/ProductFilterController";
import ProductDetailController from "../controllers/ProductDetailController";
import BookingSuccessController from '../controllers/BookingSuccessController';
import BlogDetailController from '../controllers/BlogDetailController';
import BlogController from '../controllers/BlogController';
import BlogCategoryDetailController from '../controllers/BlogCategoryDetailController';
import BlogCategoryController from '../controllers/BlogCategoryController';
import AboutUsController from '../controllers/AboutUsController';
import ContactUsController from '../controllers/ContactUsController';
import FaqController from '../controllers/FaqController';
import TermsConditionController from '../controllers/TermsConditionController';
import LanguagePrefixRedirect from './LanguagePrefixRedirect';
import LanguageSyncRedirect from './LanguageSyncRedirect';
import { SyncLangFromURL } from './SyncLangFromURL';
import LanguageURLSyncRedirect from './LanguageURLSyncRedirect';



export default function MainRoutes() {
    const user = useSelector((state) => state.user);
    const token = user.token;
    const isEmailVerified = user.isEmailVerified;
    const { pathname } = useLocation();

    const ScrollToTop = () => {

        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        useEffect(() => {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 10); // Small delay to override browser behavior
        }, [pathname]);

        return null;
    };

    const cleanOldAvailabilityData = () => {
        const currentTime = Date.now();
        let storedData = JSON.parse(localStorage.getItem('productAvailability')) || {};

        let updatedData = {};

        Object.keys(storedData).forEach(productId => {
            const { timestamp } = storedData[productId];

            // Keep only data that is less than 5 minutes old
            if (currentTime - timestamp < AvailabilityResetTime) {
                updatedData[productId] = storedData[productId];
            }
        });

        // Update localStorage if any data was removed
        if (Object.keys(updatedData).length !== Object.keys(storedData).length) {
            localStorage.setItem('productAvailability', JSON.stringify(updatedData));
        }
    };

    useEffect(() => {
        cleanOldAvailabilityData()
    }, [pathname]);




    return (
        <>
            {/* <ScrollToTop /> */}
            <PageLoader loading={user.isLoading} />
            <SyncLangFromURL />
            <Routes>
                <Route path="/" element={<DashBoardLayout />}>
                    <Route path="/:lang/home" element={<HomeController />} />
                    <Route path="/home" element={<Navigate to="/en/home" replace />} />

                    <Route path="/:lang/tour/:slug" element={<ProductDetailController />} />
                    <Route path="/tour/:slug" element={<ProductDetailController />} />

                    <Route path="/:lang/attraction/:slug" element={<AttractionDetailController />} />
                    <Route path="/attraction/:slug" element={<AttractionDetailController />} />

                    <Route path="/:lang/location/*" element={<LocationDetailController />} />
                    <Route path="/location/*" element={<LocationDetailController />} />


                    <Route path="/:lang/blog" element={<BlogController />} />
                    <Route path="/blog" element={<Navigate to="/en/blog" replace />} />


                    <Route path="/:lang/blog/article/:slug" element={<BlogDetailController />} />
                    <Route path="/blog/article/:slug" element={<BlogDetailController />} />

                    <Route path="/:lang/blog/category" element={<BlogCategoryController />} />
                    <Route path="/blog/category" element={<Navigate to="/en/blog/category" replace />} />

                    <Route path="/:lang/blog/category/:slug" element={<BlogCategoryDetailController />} />


                    <Route path="/:lang/search" element={<ProductFilterController />} />
                    <Route path="/search" element={<ProductFilterController />} />

                    <Route path="/:lang/checkout" element={<CheckoutController />} />
                    <Route path="/checkout" element={<Navigate to="/en/checkout" replace />} />

                    <Route path="/:lang/booking-success/:id" element={<BookingSuccessController />} />

                    <Route path="/:lang/about-us" element={<AboutUsController />} />
                    <Route path="/about-us" element={<Navigate to="/en/about-us" replace />} />


                    <Route path="/:lang/contact-us" element={<ContactUsController />} />
                    <Route path="/contact-us" element={<Navigate to="/en/contact-us" replace />} />


                    <Route path="/:lang/faqs" element={<FaqController />} />
                    <Route path="/faqs" element={<Navigate to="/en/faqs" replace />} />

                    <Route path="/:lang/terms-and-conditions" element={<TermsConditionController />} />
                    <Route path="/terms-and-conditions" element={<Navigate to="/en/terms-and-conditions" replace />} />

                    <Route path="/:lang" element={<HomeController />} />
                    <Route path="/" element={<Navigate to="/en" replace />} />
                </Route>

                {token && isEmailVerified ? (

                    <Route path="/*" element={<PrivateRoutes />} />
                ) : token && !isEmailVerified ? (

                    <Route path="/*" element={<VerificationRoutes />} />

                ) : (

                    <Route path="/*" element={<PublicRoutes />} />
                )}
                {/* <Route path="*" element={<LanguagePrefixRedirect />} /> */}

            </Routes>
        </>


    )
}